import React from 'react';
import { Anchor, Box, Tag, Text } from 'grommet';
import PropTypes from 'prop-types';
import { getLogAction } from './LogActions';

export const EventLog = ({ event, companySlug }) => {
    const contact = event.contact;
    const contactName = contact
        ? `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim()
        : '';
    const logAction = getLogAction(event, companySlug);
    const eventDate = new Date(event.createdAt).toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
    });

    return (
        // flex={false} stops a scrolling parent from shrinking the log below
        // its natural height once the list overflows.
        <Box direction="row-responsive" flex={false}>
            <Box basis="medium">
                <Tag value={eventDate} size="xsmall" alignSelf="start" />
            </Box>
            <Box basis="xxlarge" fill="horizontal">
                <Text>
                    {contact ? (
                        <Anchor
                            label={contactName}
                            href={
                                companySlug
                                    ? `/${companySlug}/candidates/${contact.id}`
                                    : `/contacts/${contact.id}`
                            }
                        />
                    ) : (
                        <Text>[student data missing]</Text>
                    )}{' '}
                    {logAction}
                </Text>
            </Box>
        </Box>
    );
};

EventLog.propTypes = {
    event: PropTypes.shape({
        createdAt: PropTypes.string,
        contact: PropTypes.shape({
            id: PropTypes.number,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
        }),
        type: PropTypes.string,
    }),
    companySlug: PropTypes.string,
};
